import { Reducer } from 'redux';
import { IAction } from '../types';
import { localKeyInfo } from '../config';
import LocalStore from '@/utils/store';

/**
 * agora信息
 * @property {number} roleType 1主播 2观众 用户身份
 * @property {number} kalaok 0默认 1开启kala 2关闭kala
 * @property {number} microphone 0默认 1开启mic 2关闭mic
 */
export interface AgoraInfoState {
  roleType: number;
  kalaok: number;
  microphone: number;
}

const LOCALKEY = localKeyInfo.agoraInfo;
const localVoiceInfo = LocalStore.getValue<AgoraInfoState>(LOCALKEY) || {};

export const agoraInfo: AgoraInfoState = {
  roleType: 2,
  kalaok: 0,
  microphone: 0,
  ...localVoiceInfo
};

export const setAgoraInfo: (payload: AgoraInfoState) => IAction<AgoraInfoState> = (payload: AgoraInfoState) => ({
  type: 'setAgoraInfo',
  payload
});

const agoraInfoReducer: Reducer<AgoraInfoState, IAction<any>> = (state = agoraInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setAgoraInfo':
      LocalStore.setValue(LOCALKEY, payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default agoraInfoReducer;
